// extracted by mini-css-extract-plugin
export default {"job-title":"style_job-title__yC+JF","jobTitle":"style_job-title__yC+JF"};